export const sanitizeLoginReturnPath = (candidate?: string | null) => {
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return null;
  }
  try {
    const parsedUrl = new URL(candidate, window.location.origin);
    if (
      parsedUrl.origin !== window.location.origin ||
      parsedUrl.pathname.startsWith("/login")
    ) {
      return null;
    }
    return [
      parsedUrl.pathname,
      parsedUrl.search,
      parsedUrl.hash,
    ].join("");
  } catch {
    return null;
  }
};
